import React, { PureComponent } from "react";

import Dropzone from "react-dropzone";
import cx from "classnames";
import "./ImageUploader.scss";
import querystring from "querystring";
import { uploadFile } from "@appcraft/form-sdk/http";

function uploadAssetFile(file, options) {
  let url = window.__DATA__.api.image;
  if (options) {
    url += "?" + querystring.stringify(options);
  }

  return uploadFile(url, file);
}

const Image = ({ src, style, ...props }) => (
  <div
    style={{ ...style, backgroundImage: `url(${src})`, backgroundPosition: "center", backgroundSize: "cover" }}
    {...props}
  />
);

export default class ImageUploader extends PureComponent {
  state = {
    uploading: false
  };
  handleDrop = async (accepted, rejected) => {
    const { maxWidth, maxHeight, disabled } = this.props;
    if (disabled) return;
    if (accepted.length > 0) {
      this.setState({ uploading: true });
      try {
        const json = await uploadAssetFile(accepted[0], {
          maxWidth,
          maxHeight
        });
        const { onChange, field } = this.props;
        if (onChange) {
          this.setState({ uploading: false });
          onChange(field, json);
        }
      } catch (e) {
        this.setState({ uploading: false });
        console.log(e);
      }
    } else {
      console.warn("no images to upload");
    }
  };

  handleRemove = e => {
    e.stopPropagation();
    e.preventDefault();
    const { onChange, field, disabled } = this.props;
    if (disabled) return;
    if (onChange) {
      onChange(field, null);
    }
  };

  render() {
    const { value, style = {}, placeholder, required, disabled } = this.props;
    const { uploading } = this.state;
    if (value && value.uri) {
      return (
        <div
          className={cx("ac-table__image", "af-image-dropzone", "af-image-dropzone--filled", disabled && "af-image-dropzone--disabled")}
          style={style}
        >
          <Image src={value.uri} style={{ width: "100%", height: "100%" }} />
          {!disabled && (
            <div
              className="af-image-dropzone__remove"
              onClick={this.handleRemove}
              style={{ lineHeight: style.height ? style.height + "px" : "50px" }}
            >
              ×
            </div>
          )}
        </div>
      );
    }
    return (
      <Dropzone
        className="af-image-dropzone"
        activeClassName="af-image-dropzone--active"
        rejectClassName="af-image-dropzone--rejected"
        disabledClassName="af-image-dropzone--disabled"
        style={style}
        accept="image/jpg, image/jpeg, image/png, image/gif"
        multiple={false}
        onDrop={this.handleDrop}
        disabled={disabled}
        inputProps={{ required, disabled }}
      >
        <div className="af-image-dropzone__text">{uploading ? "upload..." : placeholder}</div>
      </Dropzone>
    );
  }
}
